// Hover-revealed row action cluster: an edit button (opens the task modal/detail)
// and a trash button (delete). Shared by the project task rows (TaskRow /
// TaskRowKompakt) and the generic record rows (RecordRow) so the affordance is
// identical everywhere. Lives in its own module to avoid an import cycle between
// those row components.
//
// Hidden until the row is hovered/focused, and only on ≥md where the desktop
// row layout is visible (mobile uses tap-to-open card layouts with no hover).

import { Pencil, Plus, Trash2 } from "lucide-preact";

export function RowActions(props: {
  title: string;
  onEdit: () => void;
  onDelete: () => void | Promise<void>;
  /** UX-Vorschlag P6: „Sub-Aufgabe anlegen" als Zeilenaktion (nur mit Flag
   *  gesetzt) — statt eines eigenen Knopfs unter jeder Zeile. */
  onAddSubtask?: () => void;
}): preact.JSX.Element {
  return (
    <div class="hidden md:flex shrink-0 items-center justify-end gap-0.5 opacity-0 group-hover:opacity-100 focus-within:opacity-100 transition-opacity">
      {props.onAddSubtask && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            props.onAddSubtask?.();
          }}
          class="inline-flex items-center justify-center size-6 rounded text-[color:var(--color-on-surface-variant)] hover:bg-[color:var(--color-surface-container-high)] hover:text-[color:var(--color-on-surface)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-primary)] transition-colors"
          aria-label={`Sub-Aufgabe in „${props.title}" anlegen`}
          title="Sub-Aufgabe anlegen (a)"
        >
          <Plus size={14} aria-hidden="true" />
        </button>
      )}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          props.onEdit();
        }}
        class="inline-flex items-center justify-center size-6 rounded text-[color:var(--color-on-surface-variant)] hover:bg-[color:var(--color-surface-container-high)] hover:text-[color:var(--color-on-surface)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-primary)] transition-colors"
        aria-label={`Aufgabe „${props.title}" bearbeiten`}
        title="Bearbeiten"
      >
        <Pencil size={14} aria-hidden="true" />
      </button>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          void props.onDelete();
        }}
        class="inline-flex items-center justify-center size-6 rounded text-[color:var(--color-on-surface-variant)] hover:bg-[color:var(--color-prio-urgent)]/15 hover:text-[color:var(--color-prio-urgent)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-prio-urgent)] transition-colors"
        aria-label={`Aufgabe „${props.title}" löschen`}
        title="Löschen"
      >
        <Trash2 size={14} aria-hidden="true" />
      </button>
    </div>
  );
}
